import { CommentStreamVisibility } from "src/generated/graphqlTypes";
import { useCommentableInboxQuery } from "src/routes/inbox/components/CommentableInbox.generated";
import { queryResult } from "src/utils";
import { Inbox } from "./Inbox";

export type InboxProps = {
  commentableId: string;
  visibility: CommentStreamVisibility;
  displayCommentableNames?: { closeStream: boolean; openStream: boolean };
};

export function CommentableInbox({ commentableId, visibility, displayCommentableNames }: InboxProps) {
  const query = useCommentableInboxQuery({ variables: { id: commentableId } });
  return queryResult(query, ({ commentable }) => (
    <Inbox
      commentableId={commentable.id}
      streams={commentable.streams}
      visibility={visibility}
      displayCommentableNames={displayCommentableNames}
    />
  ));
}
